<template>
  <AddonCard
    link="https://docs.mailslurp.com/verification"
    icon="emailVerification"
    :data-change="changeIndex"
    :title="'Email address verification'"
    :subtitle="'Verify recipient email addresses.'"
    :loading="loading"
    addon-id="verification"
    :data-has-button="hasSubscriptionAndNoAddon ? '1' : '0'"
    :data-bad-currency-or-schedule="!product ? '1' : '0'"
    :no-footer="!hasSubscriptionAndNoAddon"
  >
    <div class="text-center" v-if="product">
      <TablePrice
        v-if="product.perUnitCost"
        :symbol="selectedCurrencySymbol"
        :currency="selectedCurrency"
        :price="product.perUnitCost"
        :text="'per ' + product.batchSize + ' validation'"
      />
    </div>
    <AddonNotSupported v-else />
    <template #footer>
      <UpgradeButtonAddAddonPlan
        v-if="hasSubscriptionAndNoAddon"
        expedite
        :addon="AppendProductAddonPlanAddonEnum.VALIDATION"
      />
    </template>
  </AddonCard>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useStore3 } from '../../../store/main';
import { storeToRefs } from 'pinia';
import AddonNotSupported from '../AddonNotSupported.vue';
import AddonCard from '../AddonCardSm.vue';
import UpgradeButtonAddAddonPlan from '../../pricing/addon/UpgradeButtonAddAddonPlan.vue';
import { loadFetchMany } from '../../../lib/services/helpers';
import TablePrice from '../../pricing/TablePrice.vue';
import { AppendProductAddonPlanAddonEnum } from '@mailslurp/admin-sdk';

const store3 = useStore3();

const loading = ref<boolean>(false);

defineProps<{
  changeIndex: number;
}>();

const {
  selectedCurrency,
  selectedCurrencySymbol,
  validationPlan,
  subscription,
  productEmailValidation,
} = storeToRefs(store3);
const product = computed(() => productEmailValidation.value?.products?.[0]);
const hasSubscriptionAndNoAddon = computed(() => {
  return subscription.value && !validationPlan.value;
});

onMounted(async () => {
  await loadFetchMany(
    [
      () => store3.getProductEmailValidation(),
      () => store3.getValidationPlans(),
    ],
    store3,
    loading,
  );
});
</script>
